import React, { SetStateAction } from 'react';
import { Radio } from 'src/core/forms';
import classnames from 'classnames';
import classes from 'src/components/CustomisationPage/CustomRadioMethod.scss';

import { Svg } from '../Svg/Svg';
import { SvgIconNames } from '../Svg/icons-types';

type Props = {
    id: string;
    value: string;
    title?: string;
    description?: string;
    meta?: React.ReactNode;
    icon?: SvgIconNames;
    disabled?: boolean;
    descriptionTitle?: string;
    image?: string;
    customStyle?: boolean;
    setApplicationMethodId: React.Dispatch<SetStateAction<string>>;
    applicationMethodId: string;
    isRecommended?: boolean;
    stitching?: boolean;
};

export const CustomRadioMethod: React.FC<Props> = (props) => {
    const {
        id,
        value,
        title,
        image,
        description,
        meta,
        icon,
        customStyle,
        disabled,
        descriptionTitle,
        setApplicationMethodId,
        applicationMethodId,
        isRecommended,
        stitching,
    } = props;

    return (
        <div
            className={classnames(classes.container, {
                [classes.containerRecommended]: isRecommended,
            })}
            onClick={() => !disabled && setApplicationMethodId(value)}
        >
            <label
                className={classnames(classes.label, {
                    [classes.labelDescription]: descriptionTitle,
                    [classes.labelBorder]: applicationMethodId === value,
                    [classes.labelDisabled]: disabled,
                })}
                htmlFor={id}
                data-test-id="CustomRadio_label"
                data-status={!(applicationMethodId === value)}
            >
                {isRecommended && <div className={classes.informationRecommended}>Recommended</div>}
                <div className={classes.information}>
                    <img
                        className={classnames(classes.checkIcon, classes.checkIconMobile)}
                        src={require('../../svg/check-circle.svg')}
                        alt="check circle"
                    />
                    <Radio className={classes.input} value={value} id={id} disabled={disabled} />

                    <div className={classes.information_wrapper}>
                        <span className={classes.content}>
                            {title && (
                                <strong
                                    className={classnames(classes.title, classes.titleCustom, {
                                        [classes.titleAlt]: !description,
                                    })}
                                >
                                    <span>
                                        {title}
                                        {stitching && <span className={classes.stitching}>{' (Stitching)'}</span>}
                                    </span>
                                    {icon && (
                                        <Svg
                                            className={classnames(classes.icon, {
                                                [classes.inputColor]: applicationMethodId === value,
                                            })}
                                            name={icon}
                                        />
                                    )}
                                </strong>
                            )}

                            {descriptionTitle && (
                                <span>
                                    <b>{descriptionTitle}</b>
                                </span>
                            )}
                            {description && (
                                <p className={classnames(classes.desc, classes.customDesc)}>{description}</p>
                            )}
                        </span>
                    </div>
                </div>

                {meta && (
                    <small
                        className={classnames(classes.meta, {
                            [classes.metaCustomStyle]: customStyle,
                        })}
                    >
                        {meta}
                    </small>
                )}
                {image && <img src={image} className={classes.customRadioImg} alt="" />}
                <img className={classes.checkIcon} src={require('../../svg/check-circle.svg')} alt="check circle" />
            </label>
        </div>
    );
};
